// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found-page {
  --nf-bg: #f4f7fb;
  --nf-surface: #ffffff;
  --nf-border: rgba(15, 23, 42, 0.08);
  --nf-text: #0f172a;
  --nf-muted: #64748b;
  --nf-accent: #5ea1d8;
  --nf-accent-soft: rgba(94, 161, 216, 0.12);
  --nf-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
  --nf-code-bg: #eef3f8;
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px 56px;
  background: radial-gradient(circle at top right, rgba(94, 161, 216, 0.18), transparent 42%), radial-gradient(circle at bottom left, rgba(16, 185, 129, 0.08), transparent 36%), var(--nf-bg);
  color: var(--nf-text);
  font-family: "Raleway", "Open Sans", sans-serif;
  box-sizing: border-box;
}
.not-found-page.theme-dark {
  --nf-bg: #0b1220;
  --nf-surface: #111827;
  --nf-border: rgba(148, 163, 184, 0.16);
  --nf-text: #f8fafc;
  --nf-muted: #94a3b8;
  --nf-accent: #7eb8e8;
  --nf-accent-soft: rgba(126, 184, 232, 0.16);
  --nf-shadow: 0 22px 48px rgba(0, 0, 0, 0.35);
  --nf-code-bg: #1e293b;
}

.not-found-inner {
  width: 100%;
  max-width: 760px;
  background: var(--nf-surface);
  border: 1px solid var(--nf-border);
  border-radius: 20px;
  box-shadow: var(--nf-shadow);
  padding: 40px 36px 32px;
  text-align: left;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  background: var(--nf-accent-soft);
  color: var(--nf-accent);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin-bottom: 12px;
}
.status-badge .material-icons {
  font-size: 18px;
}

.error-code {
  margin: 0;
  font-size: clamp(64px, 12vw, 96px);
  line-height: 0.9;
  font-weight: 800;
  letter-spacing: -0.04em;
  color: var(--nf-accent);
  opacity: 0.9;
}

h1 {
  margin: 12px 0 10px;
  font-size: clamp(26px, 4vw, 34px);
  line-height: 1.2;
  font-weight: 800;
  color: var(--nf-text);
}

.lead {
  margin: 0 0 18px;
  font-size: 16px;
  line-height: 1.6;
  color: var(--nf-muted);
  max-width: 54ch;
}

.attempted-url {
  margin: 0 0 22px;
  font-size: 14px;
  color: var(--nf-muted);
}
.attempted-url code {
  display: inline-block;
  margin-left: 6px;
  padding: 4px 8px;
  border-radius: 8px;
  background: var(--nf-code-bg);
  color: var(--nf-text);
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 13px;
  word-break: break-all;
}

.primary-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 28px;
}

.btn-primary,
.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 12px;
  padding: 12px 18px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  border: 1px solid transparent;
}
.btn-primary .material-icons,
.btn-secondary .material-icons {
  font-size: 18px;
}
.btn-primary:hover,
.btn-secondary:hover {
  transform: translateY(-1px);
}

.btn-primary {
  background: var(--nf-accent);
  color: #fff;
  box-shadow: 0 8px 20px rgba(94, 161, 216, 0.28);
}
.btn-primary:hover {
  filter: brightness(1.05);
}

.btn-secondary {
  background: transparent;
  color: var(--nf-text);
  border-color: var(--nf-border);
}
.btn-secondary:hover {
  background: var(--nf-accent-soft);
  border-color: rgba(94, 161, 216, 0.35);
}

.help-section h2 {
  margin: 0 0 14px;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--nf-muted);
}

.help-grid {
  display: grid;
  gap: 10px;
}

.help-card {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 14px;
  width: 100%;
  text-align: left;
  padding: 14px 16px;
  border-radius: 14px;
  border: 1px solid var(--nf-border);
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}
.help-card:hover {
  background: var(--nf-accent-soft);
  border-color: rgba(94, 161, 216, 0.35);
  transform: translateY(-1px);
}

.help-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--nf-accent-soft);
  color: var(--nf-accent);
  font-size: 22px !important;
}

.help-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.help-label {
  font-size: 15px;
  font-weight: 700;
  color: var(--nf-text);
}

.help-desc {
  font-size: 13px;
  line-height: 1.45;
  color: var(--nf-muted);
}

.help-chevron {
  color: var(--nf-muted);
  font-size: 22px !important;
}

.footnote {
  margin: 24px 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: var(--nf-muted);
}
.footnote a {
  color: var(--nf-accent);
  font-weight: 700;
  text-decoration: none;
}
.footnote a:hover {
  text-decoration: underline;
}

@media (max-width: 640px) {
  .not-found-page {
    padding: 24px 14px 40px;
    min-height: calc(100vh - 64px);
  }
  .not-found-inner {
    padding: 28px 18px 22px;
    border-radius: 16px;
  }
  .primary-actions {
    flex-direction: column;
  }
  .primary-actions .btn-primary,
  .primary-actions .btn-secondary {
    width: 100%;
    justify-content: center;
  }
  .help-card {
    grid-template-columns: auto 1fr;
    gap: 12px;
  }
  .help-card .help-chevron {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/not-found/not-found.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0CAAA;EACA,+CAAA;EACA,qBAAA;EAEA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,4LACE;EAGF,qBAAA;EACA,+CAAA;EACA,sBAAA;AAHF;AAKE;EACE,gBAAA;EACA,qBAAA;EACA,sCAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,2CAAA;EACA,4CAAA;EACA,qBAAA;AAHJ;;AAOA;EACE,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,kCAAA;EACA,mBAAA;EACA,4BAAA;EACA,uBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,iCAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AAJF;AAME;EACE,eAAA;AAJJ;;AAQA;EACE,SAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;AALF;;AAQA;EACE,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AALF;;AAQA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AALF;;AAQA;EACE,gBAAA;EACA,eAAA;EACA,sBAAA;AALF;AAOE;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qBAAA;EACA,qEAAA;EACA,eAAA;EACA,qBAAA;AALJ;;AASA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AANF;;AASA;;EAEE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,8EAAA;EACA,6BAAA;AANF;AAQE;;EACE,eAAA;AALJ;AAQE;;EACE,2BAAA;AALJ;;AASA;EACE,4BAAA;EACA,WAAA;EACA,+CAAA;AANF;AAQE;EACE,wBAAA;AANJ;;AAUA;EACE,uBAAA;EACA,qBAAA;EACA,8BAAA;AAPF;AASE;EACE,iCAAA;EACA,sCAAA;AAPJ;;AAYE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AATJ;;AAaA;EACE,aAAA;EACA,SAAA;AAVF;;AAaA;EACE,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kCAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,gFAAA;AAVF;AAYE;EACE,iCAAA;EACA,sCAAA;EACA,2BAAA;AAVJ;;AAcA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,uBAAA;EACA,0BAAA;AAXF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAXF;;AAcA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;AAXF;;AAcA;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;AAXF;;AAcA;EACE,sBAAA;EACA,0BAAA;AAXF;;AAcA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAXF;AAaE;EACE,uBAAA;EACA,gBAAA;EACA,qBAAA;AAXJ;AAaI;EACE,0BAAA;AAXN;;AAgBA;EACE;IACE,uBAAA;IACA,8BAAA;EAbF;EAgBA;IACE,uBAAA;IACA,mBAAA;EAdF;EAiBA;IACE,sBAAA;EAfF;EAiBE;;IAEE,WAAA;IACA,uBAAA;EAfJ;EAmBA;IACE,+BAAA;IACA,SAAA;EAjBF;EAmBE;IACE,aAAA;EAjBJ;AACF","sourcesContent":[".not-found-page {\n  --nf-bg: #f4f7fb;\n  --nf-surface: #ffffff;\n  --nf-border: rgba(15, 23, 42, 0.08);\n  --nf-text: #0f172a;\n  --nf-muted: #64748b;\n  --nf-accent: #5ea1d8;\n  --nf-accent-soft: rgba(94, 161, 216, 0.12);\n  --nf-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);\n  --nf-code-bg: #eef3f8;\n\n  min-height: calc(100vh - 80px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px 56px;\n  background:\n    radial-gradient(circle at top right, rgba(94, 161, 216, 0.18), transparent 42%),\n    radial-gradient(circle at bottom left, rgba(16, 185, 129, 0.08), transparent 36%),\n    var(--nf-bg);\n  color: var(--nf-text);\n  font-family: \"Raleway\", \"Open Sans\", sans-serif;\n  box-sizing: border-box;\n\n  &.theme-dark {\n    --nf-bg: #0b1220;\n    --nf-surface: #111827;\n    --nf-border: rgba(148, 163, 184, 0.16);\n    --nf-text: #f8fafc;\n    --nf-muted: #94a3b8;\n    --nf-accent: #7eb8e8;\n    --nf-accent-soft: rgba(126, 184, 232, 0.16);\n    --nf-shadow: 0 22px 48px rgba(0, 0, 0, 0.35);\n    --nf-code-bg: #1e293b;\n  }\n}\n\n.not-found-inner {\n  width: 100%;\n  max-width: 760px;\n  background: var(--nf-surface);\n  border: 1px solid var(--nf-border);\n  border-radius: 20px;\n  box-shadow: var(--nf-shadow);\n  padding: 40px 36px 32px;\n  text-align: left;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: var(--nf-accent-soft);\n  color: var(--nf-accent);\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  margin-bottom: 12px;\n\n  .material-icons {\n    font-size: 18px;\n  }\n}\n\n.error-code {\n  margin: 0;\n  font-size: clamp(64px, 12vw, 96px);\n  line-height: 0.9;\n  font-weight: 800;\n  letter-spacing: -0.04em;\n  color: var(--nf-accent);\n  opacity: 0.9;\n}\n\nh1 {\n  margin: 12px 0 10px;\n  font-size: clamp(26px, 4vw, 34px);\n  line-height: 1.2;\n  font-weight: 800;\n  color: var(--nf-text);\n}\n\n.lead {\n  margin: 0 0 18px;\n  font-size: 16px;\n  line-height: 1.6;\n  color: var(--nf-muted);\n  max-width: 54ch;\n}\n\n.attempted-url {\n  margin: 0 0 22px;\n  font-size: 14px;\n  color: var(--nf-muted);\n\n  code {\n    display: inline-block;\n    margin-left: 6px;\n    padding: 4px 8px;\n    border-radius: 8px;\n    background: var(--nf-code-bg);\n    color: var(--nf-text);\n    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n    font-size: 13px;\n    word-break: break-all;\n  }\n}\n\n.primary-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 28px;\n}\n\n.btn-primary,\n.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 12px;\n  padding: 12px 18px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n  border: 1px solid transparent;\n\n  .material-icons {\n    font-size: 18px;\n  }\n\n  &:hover {\n    transform: translateY(-1px);\n  }\n}\n\n.btn-primary {\n  background: var(--nf-accent);\n  color: #fff;\n  box-shadow: 0 8px 20px rgba(94, 161, 216, 0.28);\n\n  &:hover {\n    filter: brightness(1.05);\n  }\n}\n\n.btn-secondary {\n  background: transparent;\n  color: var(--nf-text);\n  border-color: var(--nf-border);\n\n  &:hover {\n    background: var(--nf-accent-soft);\n    border-color: rgba(94, 161, 216, 0.35);\n  }\n}\n\n.help-section {\n  h2 {\n    margin: 0 0 14px;\n    font-size: 15px;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n    color: var(--nf-muted);\n  }\n}\n\n.help-grid {\n  display: grid;\n  gap: 10px;\n}\n\n.help-card {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 14px;\n  width: 100%;\n  text-align: left;\n  padding: 14px 16px;\n  border-radius: 14px;\n  border: 1px solid var(--nf-border);\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;\n\n  &:hover {\n    background: var(--nf-accent-soft);\n    border-color: rgba(94, 161, 216, 0.35);\n    transform: translateY(-1px);\n  }\n}\n\n.help-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--nf-accent-soft);\n  color: var(--nf-accent);\n  font-size: 22px !important;\n}\n\n.help-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.help-label {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--nf-text);\n}\n\n.help-desc {\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--nf-muted);\n}\n\n.help-chevron {\n  color: var(--nf-muted);\n  font-size: 22px !important;\n}\n\n.footnote {\n  margin: 24px 0 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--nf-muted);\n\n  a {\n    color: var(--nf-accent);\n    font-weight: 700;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n@media (max-width: 640px) {\n  .not-found-page {\n    padding: 24px 14px 40px;\n    min-height: calc(100vh - 64px);\n  }\n\n  .not-found-inner {\n    padding: 28px 18px 22px;\n    border-radius: 16px;\n  }\n\n  .primary-actions {\n    flex-direction: column;\n\n    .btn-primary,\n    .btn-secondary {\n      width: 100%;\n      justify-content: center;\n    }\n  }\n\n  .help-card {\n    grid-template-columns: auto 1fr;\n    gap: 12px;\n\n    .help-chevron {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
